import Tweezer from 'tweezer.js'
import debounce from 'lodash/debounce'

export const isMobile = () => window.innerWidth < 768

export const supportsObjectFit = () => {
  let objectFit = false
  for (let prop in document.documentElement.style) {
    if (/object(?:-f|F)it$/.test(prop)) {
      objectFit = true
      break
    }
  }
  return objectFit
}

export const isIE = () => {
  return navigator.userAgent.toLowerCase().indexOf('msie') > 0
}

export const isIEorEdge = () => {
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}

export const isFirefox = () => {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1
}

export const write = (el, value) => {
  el.innerHTML = value
}

export const set = (item, selector) => {
  if (item instanceof Array) {
    for (let i of item) {
      i.classList.add(selector)
    }
  } else {
    item.classList.add(selector)
  }
}

export const unset = (item, selector) => {
  if (item instanceof Array) {
    for (let i of item) {
      i.classList.remove(selector)
    }
  } else {
    item.classList.remove(selector)
  }
}

export const contains = (item, selector) => {
  return item.classList.contains(selector)
}

export const toggle = (item, selector) => {
  if (item instanceof Array) {
    for (let i of item) {
      i.classList.toggle(selector)
    }
  } else {
    item.classList.toggle(selector)
  }
}

export const getHeight = (el) => {
  return `${el.offsetHeight}px`
}

export const getWidth = (el) => {
  return `${el.offsetWidth}px`
}

export const isOver = (breakpoint) => {
  return (window.innerWidth > breakpoint)
}

export const deepClone = obj => {
  return JSON.parse(JSON.stringify(obj))
}

export const formatPrice = (num, fraction = 0, hasDigits = false) => {
  const price = (Number(num) / 100)
  if (!hasDigits && price % 1 === 0) {
    return price
  }

  return price.toLocaleString('en-EN', {
    minimumFractionDigits: fraction,
    maximumFractionDigits: 2
  })
}

export const getUrlParam = name => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]') // eslint-disable-line
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export const handleize = str => str.replace(/[ /_]/g, '-').toLowerCase()

/**
 * Decodes a string that has been encode through the 'url_encode' Shopify filter
 * @param {*} str
 */
export const decode = str => decodeURIComponent(str).replace(/\+/g, ' ')

/**
 * Generates a URL that is suitable for the Shopify
 * image CDN. Adds the current image size suffix.
 *
 * @param {*} src
 * @param {*} size
 */
export const getImageWithSize = (src = '', size = 1000) => {
  return ('' + src).replace(/([.](?:jpe?g|png))/, `_${size}x$1`)
}

/**
 * Used by components like the product card to select
 * the current product image based on the active color.
 * If there is no active color, a fallback image
 * should be returned if it is defined.
 *
 * @param {*} color
 * @param {*} images
 * @param {*} featured
 * @param {*} fallback
 */
export const getProductImage = (name = '', value = '', images, featured = false, fallback = false) => {
  const key = `${name}-${(value || '').replace(/[/ ]/g, '-')}`.toLowerCase()
  const image = (images || []).find(i => {
    return ~i.indexOf(key) && ~i.indexOf(
      featured ? 'pos-1' : 'pos-2'
    )
  })
  if (!image) {
    return getImageWithSize(fallback, 600)
  }
  return getImageWithSize(image, featured ? 1200 : 600)
}

export const createArrayFromNumRange = (size, start) => {
  return Array.from(Array(size), (_, i) => start + i)
}

export const createMonthArray = () => {
  return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
}

export const isTouchDevice = () => {
  return (
    !!(typeof window !== 'undefined' && ('ontouchstart' in window || (window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch))) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
  )
}

/* Element.closest() polyfill for IE11 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this

    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

export const refreshYotpoWidgets = debounce(() => {
  if (!window.Yotpo) {
    let checker = setInterval(() => {
      if (window.Yotpo) {
        clearInterval(checker)
        refreshYotpoWidgets()
      }
    }, 1000)
    return null
  }
  const api = new window.Yotpo.API(yotpo)
  api.refreshWidgets()
}, 2000)

export function isSubscriptionVariant ({ title }) {
  return title.toLowerCase().includes('subscription')
}

export function hasSubscriptionOption (product) {
  return product.subscription && product.subscription.hasOwnProperty('subscription_id')
}

export const uniqueNumber = () => {
  return Math.floor(100000000 + Math.random() * 900000000)
}

export const getOffset = (el, win = window, docElem = document.documentElement, box = false) => {
  box = el.getBoundingClientRect()
  return box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0)
}

export const scrollTo = (el, offset = 0, duration = 1000, callback = () => {}) => {
  new Tweezer({
    start: window.scrollY || window.pageYOffset,
    end: getOffset(el) - offset,
    duration: duration
  })
    .on('tick', v => window.scrollTo(0, v))
    .on('done', callback)
    .begin()
}

export const deliveryFrequencyNote = (properties) => {
  const subsriptionDuration = properties.shipping_interval_frequency ? Number(properties.shipping_interval_frequency) : 0
  const subscriptionUnit = properties.shipping_interval_unit_type || ''
  return `Delivers every ${subsriptionDuration === 1 ? subscriptionUnit.toLowerCase().replace('s', '') : 'other ' + subscriptionUnit.toLowerCase().replace('s', '')}`
}

export const getPerUnitPrice = (variant) => {
  if (!variant || isNaN(variant.pack_size) || !variant.pack_size) return null
  return `$${formatPrice(variant.price / variant.pack_size, 2)} per ${variant.pack_size_unit ? variant.pack_size_unit : 'unit'}`
}
